"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cart = exports.A11yButton = exports.Modal = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactDiv100vh = _interopRequireDefault(require("react-div-100vh"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Modal = (0, _styledComponents["default"])(_reactDiv100vh["default"])(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  padding-top: 84px;\n  position: relative;\n  z-index: 1002;\n  pointer-events: none;\n"], ["\n  padding-top: 84px;\n  position: relative;\n  z-index: 1002;\n  pointer-events: none;\n"])));
exports.Modal = Modal;

var A11yButton = _styledComponents["default"].button(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  background: #fff;\n  border: none;\n  padding: 0 4px 8px 4px;\n  margin: 0;\n  cursor: pointer;\n\n  :focus-visible {\n    outline: 2px solid black;\n    outline-offset: 2px;\n  }\n"], ["\n  background: #fff;\n  border: none;\n  padding: 0 4px 8px 4px;\n  margin: 0;\n  cursor: pointer;\n\n  :focus-visible {\n    outline: 2px solid black;\n    outline-offset: 2px;\n  }\n"])));

exports.A11yButton = A11yButton;
var Cart = (0, _styledComponents["default"])(_slice.Flex)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  display: flex;\n  border-color: ", ";\n  border-width: 4px;\n  border-style: solid;\n  background-color: ", ";\n  height: 100%;\n  overflow-y: scroll;\n  pointer-events: auto;\n"], ["\n  display: flex;\n  border-color: ", ";\n  border-width: 4px;\n  border-style: solid;\n  background-color: ", ";\n  height: 100%;\n  overflow-y: scroll;\n  pointer-events: auto;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
exports.Cart = Cart;
var templateObject_1, templateObject_2, templateObject_3;